import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ChangePasswordForm from './components/ChangePasswordForm'

import './style.scss'

export default class ChangePassword extends Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
    }

    render() {
        const { id } = this.props

        return (
            <div className={'content-change-password'}>
                <ChangePasswordForm contentId={id} />
            </div>
        )
    }
}
